<template>
    <div class="root" v-loading="loading">
        
        
      <topmenu></topmenu>


            <!-- content -->
            
  <div class="container theme-showcase">
    <div class="page-header" style="margin: 0; display: flex; align-items: flex-end;">
      <div style="color: #4a8cef; font-weight: bold; flex: 1; font-size: 26px;">
            <i class="el-icon-circle-plus-outline" style="color: #000; cursor: pointer; " @click="toAdd"></i>
            Event List
            </div>
      <div>
        <div style="margin-top: 15px;">
            <el-input placeholder="请输入内容" v-model="searchTxt" class="input-with-select" clearable>
                <el-button slot="append" @click="search">Search</el-button>
            </el-input>
        </div>
      </div>
    </div>

    <div class="divItem" v-for="(item, index) in list" :key="item.id" :class="{'Finished':item.isFinish}" >
      <div v-if="!item.isFinish" class="eventStatus">Progressing</div>
      <div v-else class="eventStatus Finished">Finished</div>
      
      <div class="eventTitle" @click="toEdit(item.id)">{{item.eventName}}</div>
      
      <div class="eventPP">
        <div>Event Date: {{item.beginDtStr}} ~ {{item.endDtStr}}</div>
        <div>Event Address: {{item.address}}</div>
      </div>

      
      <div class="eventNumber">
        <div class="eventRegistered">
          <span>Registered people: </span><span class="registeredNumber">{{item.visitorCount}}</span>
        </div>
        <div class="eventCheckin">
          <span>Check-in people: </span><span class="checkinNumber">{{item.CheckinCount}}</span>
        </div>
      </div>

      <div class="eventButtons">
        <div style="flex: 1;">
          <div>
            <el-button type="success" size="mini" icon="el-icon-s-operation"> General</el-button>
            <el-button type="primary" size="mini" icon="el-icon-s-tools">Setting</el-button>
            <el-button type="warning" size="mini" icon="el-icon-s-data">Data Statistics</el-button>
            
            <router-link target="_blank" :to="{path:'/selectcate',query:{id: item.eventCode}}">
            <el-button type="success" size="mini" icon="el-icon-view" @click="toReg(item.eventCode)">Reg Page</el-button>
          </router-link>
          </div>
        </div>
        <div>
          <div class="eventTime">
            Creation Time: <span class="creationTime">{{item.createDT}}</span>
          </div>
        </div>
      </div>
    </div>


<div v-if="total>1">
  <el-pagination
  background
  layout="prev, pager, next"
  @current-change="handleCurrentChange"
  :current-page.sync="currentPage"
  :total="total">
</el-pagination>
</div>

    
<div style="height: 55px;"></div>
  </div>
<!-- content -->

    </div>
</template>

<script>

import axios from 'axios'
import topmenu from '../home/components/topmenu'

export default {
    name: 'eventlist',
    data: function () {
        return {
          currentPage:1,
            nickname:'',
            loading:false,
            searchTxt:"",
            list:[],
            total:0
        }
    },
    components: {
      topmenu
    },
    methods: {
      toReg(id){
        // this.$router.push("selectcate?id="+id);
//         this.$router.push(
//           {
//   path: '/selectcate',
//   query: {
//     id: id
//   }
// }
//         )
      },
      toEdit(id){
this.$router.push("/addevent?id="+id);
      },
      handleCurrentChange(page){
console.log(page)
this.loadData(page);
      },
      search(){
        this.currentPage=1;
this.loadData(1);
      },
        loadData(page) {
            this.loading = true;
            var userJson = JSON.parse(localStorage.getItem('userJson'));
            axios.post('/api/event/getList',
                {
                  skip:(page-1)*10,
                    limit: 10,
                    uid: userJson.uid,
                    token: userJson.token,
                    search:this.searchTxt
                }
            )
                .then(this.loadDataSucc)
        },
        loadDataSucc(res) {
            this.loading=false;
            res = res.data
            console.log(res);
            if (res && res.Code == 200) {
                if(res.toresult==1){
                    this.$router.replace('/result');
                }else{
                this.list = res.list
                this.total = res.total;
                console.log(this.list);
                }
            }else{
                if(res && res.Code == 301){
                    localStorage.removeItem('userJson');
                    this.$router.replace('/login');
                }
            }
        },

        handleCommand(command) {
            if(command=='logout'){
                localStorage.removeItem('userJson');
                    this.$router.replace('/login');
            }
        },

        toAdd(){
            this.$router.push('/addevent');
        }
    },
    mounted() {
        this.loadData(1)
        var userJson = JSON.parse(localStorage.getItem("userJson"));
        console.log(userJson);
        var nickname = userJson['nickname'];
        this.nickname = nickname;
        console.log(this.nickname);
    },
    beforeDestroy() {
        
    }
}
</script>
<style scoped>
.root >>> .topmenuitem:nth-child(2){
    color: #fff;
 background-color: #080808;
}

.divItem{
        border: 1px #419641 solid;
        border-radius: 10px;
        margin: 15px auto;
        padding: 12px 20px;
        position: relative;
        overflow: hidden;
      }
      .eventStatus{
        padding: 0 30px;
        position: absolute;
        right: -34px;
        top: 24px;
        color: #fff;
        background-color: #419641;
        transform: rotate(45deg);
      }
      .eventStatus.Finished{
        background-color: gray;
        right: -30px;
        top: 20px;
      }
      .divItem.Finished{
        background: #f8f8f8;
        border: 1px gray solid;
      }
      .divItem.divItem.Finished .btn-info{
        color: #5bc0de;
        background-color: #fff;
      }
      .divItem.divItem.Finished .btn-success{
        color: #5cb85c;
        background-color: #fff;
      }
      .divItem.divItem.Finished .btn-primary{
        color: #337ab7;
        background-color: #fff;
      }
      

      .eventTitle{
        font-size: 20px;
        font-weight: bold;
        line-height: 34px;
        cursor: pointer;
      }
      .eventTime{
        color: #666;
        font-size: 14px;
        margin: 2px 0;
        margin-top: 12px;
      }
      .eventPP{
        display: flex;
        margin: 12px 0;
      }
      .eventPP div{
        border-left: 3px gray solid;
        padding-left: 5px;
        line-height: 16px;
        margin-right: 30px;
        font-weight: normal;
        color: gray;
        font-size: 14px;
      }
      .eventButtons{
        display: flex;
      }
      .eventNumber{
        display: flex;
        flex: 1;
        margin-bottom: 12px;
      }
      .eventRegistered{
        margin-right: 15px;
        color: #ec971f;
      }
      .eventCheckin{
        color: #4a8cef;
      }
      .registeredNumber{
        font-weight: bold;
        font-size: 18px;
      }
      .checkinNumber{
        font-weight: bold;
        font-size: 18px;
      }

</style>



// WEBPACK FOOTER //
// src/pages/eventlist/eventlist.vue